import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::regenerate
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:108
* @route 'https://org.proexpert.app/org/mfa/recovery/regenerate'
*/
export const regenerate = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: regenerate.url(options),
    method: 'post',
})

regenerate.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/mfa/recovery/regenerate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::regenerate
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:108
* @route 'https://org.proexpert.app/org/mfa/recovery/regenerate'
*/
regenerate.url = (options?: RouteQueryOptions) => {
    return regenerate.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::regenerate
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:108
* @route 'https://org.proexpert.app/org/mfa/recovery/regenerate'
*/
regenerate.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: regenerate.url(options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::regenerate
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:108
* @route 'https://org.proexpert.app/org/mfa/recovery/regenerate'
*/
const regenerateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: regenerate.url(options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::regenerate
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:108
* @route 'https://org.proexpert.app/org/mfa/recovery/regenerate'
*/
regenerateForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: regenerate.url(options),
    method: 'post',
})

regenerate.form = regenerateForm

const recovery = {
    regenerate: Object.assign(regenerate, regenerate),
}

export default recovery